// extracted by mini-css-extract-plugin
export default {"cHomeSectionTransactionTable":"HomeSectionTransactionTable_cHomeSectionTransactionTable__qi9YK"};